/** @jsxImportSource @emotion/react */
import { nike } from '@nike/nike-design-tokens';
import { arrayOf, string, func } from 'prop-types';

const ToggleButtonGroup = ({ toggleOptions, selectButton, selectedButton }) => {
  return (
    <div className='input-container' css={{ display: 'flex' }}>
      {toggleOptions.map(option => (
        <label css={{ '&:last-of-type span': { borderRight: `1px solid ${nike.podiumCdsColorGrey200}` } }}>
          <input
            type='radio'
            name='radios'
            value={option}
            label={option}
            checked={selectedButton === option}
            onClick={() => selectButton(option)}
            css={{
              position: 'absolute',
              opacity: 0,
              width: 0,
              height: 0,
              '&: checked + span': {
                backgroundColor: nike.podiumCdsColorWhite,
                border: `2px solid ${nike.podiumCdsColorGrey300}`
              }
            }}
          />
          <span
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '60px',
              height: '40px',
              border: `1px solid ${nike.podiumCdsColorGrey200}`,
              borderRight: '0',
              backgroundColor: nike.podiumCdsColorGrey100,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            {option}
          </span>
        </label>
      ))}
    </div>
  );
};

ToggleButtonGroup.propTypes = {
  toggleOptions: arrayOf(string).isRequired,
  selectButton: func.isRequired,
  selectedButton: string.isRequired
};

export default ToggleButtonGroup;
